( function () {
	'use strict';

	/* eslint-disable max-params */
	function StartObsModalCtrl ( logger, apiService, $scope, $modalInstance, $filter, Session, _, moment, $q, createObsService, $location ) {
		var self = this;

		self.showLoading   = false;
		self.serverTimeout = false;
		self.fetchTimeout  = false;

		self.startObsDate = moment().format();

		var credentials = Session.getCredentials();

		function getData () {
			self.fetchTimeout = true;
			createObsService.getPreLoadedData().then( function ( q ) {
				$q.all( [ q[ 0 ].$promise, q[ 1 ].$promise ] )
				.then( function ( res ) {
					if ( res.length ) {
						self.templates = createObsService.getReorderedTemplates( res[ 0 ], res[ 1 ] );
						return self.templates;
					}

					self.fetchTimeout = false;
					return self.fetchTimeout;
				}, function () {
					self.fetchTimeout = false;
					return self.fetchTimeout;
				} );

				q[ 2 ].$promise.then( function ( districts ) {
					var schools = [];

					// look into all districts
					( districts || [] ).map( function ( district ) {
						schools = schools.concat( district.Schools || [] );
					} );

					if ( schools.length ) {
						self.schools = schools;
						return self.schools;
					}

					self.fetchTimeout = false;
					return self.fetchTimeout;
				}, function () {
					self.fetchTimeout = false;
					return self.fetchTimeout;
				} );
			} );
		}

		function watch () {
			$scope.$watch( angular.bind( this, function () {
				return this.getTeachers;
			} ), function ( val ) {
				if ( val.users && !val.users.length ) {
					self.fetchTimeout = false;
				}

				if ( !angular.equals( {}, val ) ) {
					self.disableTeacher = false;
				}
			}, true );

			$scope.$watch( angular.bind( this, function () {
				return this.selections;
			} ), function ( val ) {
				if ( !angular.equals( {}, val ) ) {
					if ( val.length === 3 ) {
						self.disableStart = false;
						return self.disableStart;
					}
					self.disableStart = true;
					return self.disableStart;
				}
			}, true );
		}

		function activate () {
			self.getData();
			self.watch();

			logger.info( 'Activated Modal View' );
		}

		function getSelfType ( item ) {
			return /^self$/i.test( item );
		}

		self.showLocation = false;

		self.submitObs = function ( type ) {
			self.showLoading   = true;
			self.serverTimeout = false;

			var location = { };

			var pointerFirstname = _.chain( self.selections ).filter( 'pointer', 'FirstName' ).pluck( 'data' ).value()[ 0 ];
			var template         = _.chain( self.selections ).filter( 'pointer', 'name' ).pluck( 'data' ).value()[ 0 ];
			var observee         = {
				'id' : credentials.userId
			};

			location.observeeClientId = credentials.ClientId;

			delete template.isFav;

			if ( type !== 1 ) {
				var observeeFirstName     = pointerFirstname.FirstName;
				var observeeLastName      = pointerFirstname.LastName;
				var data                  = {};

				location.observeeClientId = pointerFirstname.ClientId;
				observee.id               = pointerFirstname.PersonnelId;

				data = {
					'id'                : apiService.generateUUID(),
					'name'              : 'Observation of ' + observeeLastName + ', ' + observeeFirstName,
					'observee'          : observee,
					'location'          : location,
					'template'          : template,
					'partialSubmission' : true,
					'startDate'         : self.startObsDate,
					'masterEvidences'   : [],
					'tags'              : [],
					'observer'          : {
						'id' : credentials.userId
					}
				};
			}

			if ( type === 1 ) {
				data = {
					'id'                : apiService.generateUUID(),
					'name'              : 'Observation of ' + credentials.LastName + ', ' + credentials.FirstName,
					'observee'          : observee,
					'location'          : location,
					'template'          : template,
					'partialSubmission' : true,
					'startDate'         : self.startObsDate,
					'masterEvidences'   : [],
					'tags'              : [],
					'type'              : [ template.types.filter( getSelfType ).shift() ].filter( Boolean ),
					'observer'          : {
						'id' : credentials.userId
					}
				};
			}
			self.saveObs( data );
		};

		function groupMapper ( group ) {
			delete group.score;
		}

		function saveObs ( data ) {
			// remove score on data
			delete data.template.score;
			// remove group score on data
			data.template.groups.map( groupMapper );

			createObsService.saveObservation( data )
			.then( function ( res ) {
				logger.notifySuccess( 'Successfully Created!', 'Observation' );
				$location.url( $location.path() );
				$modalInstance.close( res );
			}, function () {
				self.serverTimeout = true;
				logger.notifyError( 'Unable to start this observation', 'Observation' );
			} );
		}

		function close () {
			$location.url( $location.path() );
			$modalInstance.dismiss();
		}

		self.close          = close;
		self.disableTeacher = true;
		self.getTeachers    = {};
		self.filterSchools  = true;
		self.selections     = [];
		self.disableStart   = true;
		self.teacher        = 'Select a Teacher';

		self.saveObs        = saveObs;
		self.getData        = getData;
		self.watch          = watch;

		activate();
	}

	angular
		.module( 'ui.bootstrap.modal' )
		.controller( 'StartObsModalCtrl', StartObsModalCtrl );

	StartObsModalCtrl.$inject = [ 'logger', 'apiService', '$scope', '$modalInstance', '$filter', 'Session', '_', 'moment', '$q', 'createObsService', '$location' ];
} )();
